import flagIcon from '../../assets/sidebar/Flag.svg';
import resultIcon from '../../assets/sidebar/Result.svg';
import statisticIcon from '../../assets/sidebar/Statistic.svg';
import type { SidebarIconName } from './sidebarTypes';

type SidebarIconProps = {
  name: SidebarIconName;
};

const iconByName: Record<SidebarIconName, string> = {
  flag: flagIcon,
  statistic: statisticIcon,
  result: resultIcon,
};

function SidebarIcon({ name }: Readonly<SidebarIconProps>) {
  return <img alt="" aria-hidden="true" className="sidebar-menu-icon" src={iconByName[name]} />;
}

export default SidebarIcon;
